import { swarmRequest } from "@common/helpers/util/requestMiddleware"
import { store } from "../index/terminalApp";
import { SetFreeBonuses } from "../actions/terminal";

export const checkFreeBonuses = async () => {
  const result = await swarmRequest({ free_bonuses: true }, 'get_bonus_details');
  
  if (!result.bonuses?.length) return;

  store.dispatch(SetFreeBonuses(result.bonuses));
}